import ownersApiService from '@/services/api/Owners'

const emptyModel = {
  name: null,
  is_company: false,
  company_details: {
    id: null,
    name: null
  },
  contact_details: {
    email: null,
    phone: null,
    address: null,
    city: null,
    post_code: null
  },
  country_id: null,
  has_user: false,
  user: {
    name: null,
    password: null,
    password_confirmation: null
  }
}

const emptyFilters = {
  id: null,
  name: null,
  country_id: null
}

export default class Owner {
  static api = ownersApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
